export default {
  label: {
    id: 'merchant_options_payment_payout_status_verified',
    defaultMessage: 'Your KYB information has been verified.',
  },
}
